export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";